import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Location, PlatformLocation } from '@angular/common';
import { ClipboardService } from 'ngx-clipboard';

@Component({
  selector: 'app-share-button',
  templateUrl: './share-button.component.html',
  styleUrls: ['./share-button.component.css']
})
export class ShareButtonComponent {
  @Input() isModalVisible: boolean = false;
  copySuccess: boolean = false;
  // @Input() shareUrl: string = '';
  shareUrl: string = '';
  constructor(private platformLocation: PlatformLocation,private clipboardService: ClipboardService) {
  }

  ngOnInit() {
    this.shareUrl = this.platformLocation.href;
  }
  setData(status: boolean) { 
    this.isModalVisible = status;
  }
  shareOnFacebook() {
    const encodedUrl = encodeURIComponent(this.shareUrl);
    this.close();
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`, 'sharer');
  }

  copyLinks() {
    this.copySuccess = true;
    this.clipboardService.copyFromContent(this.shareUrl); 
  }
  shareOnTwitter() { 
    const encodedUrl = encodeURIComponent(this.shareUrl);
    this.close();
    window.open(`https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedUrl}`, 'sharer');
  }
  close() {
    this.isModalVisible = false;
  }
  shareOnLinkedIn() {

    const encodedUrl = encodeURIComponent(this.shareUrl);
    this.close();
    window.open(`https://www.linkedin.com/shareArticle?url=${encodedUrl}&title=${encodedUrl}`, 'sharer');
  }
  shareOnWhatsapp() { 
    const encodedUrl = encodeURIComponent(this.shareUrl); 
    this.close();
    window.open(`https://api.whatsapp.com/send?text=${encodedUrl}`, 'sharer');
    // `https://api.whatsapp.com/sendurl=${encodedUrl}&title=${encodedUrl}`, 'sharer'); 
  }
  shareOnEmail() { 
    const encodedUrl = encodeURIComponent(this.shareUrl);
    this.close();
    window.open(`mailto:?subject=""&amp;body=Check out this site ${encodedUrl}`, 'sharer');
  }


}
